import { render } from "./ServicesList.vue?vue&type=template&id=ca5ffb38&scoped=true"
import script from "./ServicesList.vue?vue&type=script&lang=js"
export * from "./ServicesList.vue?vue&type=script&lang=js"

import "./ServicesList.vue?vue&type=style&index=0&id=ca5ffb38&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca5ffb38"]])

export default __exports__